module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_26_LICZEBNIKI_6_A.8d6373a4.mp3";